export const formConstants = {
    OPEN: 'FORM_OPEN',
    CLOSE: 'FORM_CLOSE',
    DIALOG_OPEN: 'DIALOG_OPEN',
    DIALOG_CLOSE: 'DIALOG_CLOSE',
    CLEAR_FAILURE: 'UNIT_CLEAR_FAILURE',
};
